/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CompleteCourseLessonParams,
  CourseLessonDetail,
  CourseLessonMutation,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get Course Lesson
 */
export const getCourseLesson = (
    courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
id = toValue(id);

      return axiosClient<CourseLessonDetail>(
      {url: `/courses/${courseId}/lessons/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCourseLessonQueryKey = (courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,) => {
    return [
    'courses',courseId,'lessons',id
    ] as const;
    }


export const getGetCourseLessonQueryOptions = <TData = Awaited<ReturnType<typeof getCourseLesson>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseLesson>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCourseLessonQueryKey(courseId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseLesson>>> = ({ signal }) => getCourseLesson(courseId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(courseId) !== null && toValue(courseId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseLesson>>, TError, TData>
}

export type GetCourseLessonQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseLesson>>>
export type GetCourseLessonQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get Course Lesson
 */

export function useGetCourseLesson<TData = Awaited<ReturnType<typeof getCourseLesson>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseLesson>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseLessonQueryOptions(courseId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Complete Course Lesson
 */
export const completeCourseLesson = (
    courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<CompleteCourseLessonParams>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
id = toValue(id);
params = toValue(params);

      return axiosClient<CourseLessonMutation>(
      {url: `/courses/${courseId}/lessons/${id}/complete`, method: 'PATCH',
        params, signal
    },
      );
    }




export const getCompleteCourseLessonMutationKey = () => ['completeCourseLesson'] as const;

export const getCompleteCourseLessonMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCourseLesson>>, TError,CompleteCourseLessonMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeCourseLesson>>, TError,CompleteCourseLessonMutationVariables, TContext> => {

const mutationKey = getCompleteCourseLessonMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeCourseLesson>>, CompleteCourseLessonMutationVariables> = (props) => {
          const {courseId,id,params} = props ?? {};

          return  completeCourseLesson(courseId,id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteCourseLessonMutationResult = NonNullable<Awaited<ReturnType<typeof completeCourseLesson>>>

    export type CompleteCourseLessonMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CompleteCourseLessonMutationVariables = {courseId: number;id: number;params?: CompleteCourseLessonParams}

    /**
 * @summary Complete Course Lesson
 */
export const useCompleteCourseLesson = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCourseLesson>>, TError,CompleteCourseLessonMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeCourseLesson>>,
        TError,
        CompleteCourseLessonMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteCourseLessonMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark Course Lesson Incomplete
 */
export const incompleteCourseLesson = (
    courseId: MaybeRefOrGetter<number>,
    id: MaybeRefOrGetter<number>,
 signal?: AbortSignal
) => {
      courseId = toValue(courseId);
id = toValue(id);

      return axiosClient<CourseLessonMutation>(
      {url: `/courses/${courseId}/lessons/${id}/incomplete`, method: 'PATCH', signal
    },
      );
    }




export const getIncompleteCourseLessonMutationKey = () => ['incompleteCourseLesson'] as const;

export const getIncompleteCourseLessonMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof incompleteCourseLesson>>, TError,IncompleteCourseLessonMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof incompleteCourseLesson>>, TError,IncompleteCourseLessonMutationVariables, TContext> => {

const mutationKey = getIncompleteCourseLessonMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof incompleteCourseLesson>>, IncompleteCourseLessonMutationVariables> = (props) => {
          const {courseId,id} = props ?? {};

          return  incompleteCourseLesson(courseId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IncompleteCourseLessonMutationResult = NonNullable<Awaited<ReturnType<typeof incompleteCourseLesson>>>

    export type IncompleteCourseLessonMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type IncompleteCourseLessonMutationVariables = {courseId: number;id: number}

    /**
 * @summary Mark Course Lesson Incomplete
 */
export const useIncompleteCourseLesson = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof incompleteCourseLesson>>, TError,IncompleteCourseLessonMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof incompleteCourseLesson>>,
        TError,
        IncompleteCourseLessonMutationVariables,
        TContext
      > => {
      return useMutation(getIncompleteCourseLessonMutationOptions(options), queryClient);
    }
